<!--
 * @Description: 
 * @Author: houcw
 * @Date: 2023-06-11 11:16:43
 * @LastEditTime: 2025-02-13 12:33:44
 * @LastEditors: Please set LastEditors
 * @Reference: 
-->
<template>
  <div class="chatHome">
    <div class="chatLeft" v-if="showLeft">
      <div class="topBtn" @click="newChat">
        <i class="el-icon-plus"></i>
        <span class="text">新建聊天</span>
      </div>
      <div class="online-person">
        <!-- <span class="onlin-text">聊天列表</span> -->
        <div class="person-cards-wrapper">
          <div class="personList" v-for="(personInfo, index) in personList" :key="personInfo.id"
            @click="clickPerson(personInfo)">
            <PersonCard :personInfo="personInfo" :pcCurrent="pcCurrent" :index="index" @deleteOnce="deleteOnce"
              @changeName="changeName"></PersonCard>
          </div>
        </div>
      </div>

      <div class="bootomSetting">
        <div class="item" v-for="(item, index) in settingList" :key="index" @click="loginOut(index)">
          <i :class="item.icon"></i>
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
    <div class="chatRight">
      <div>
        <!-- @personCardSort="personCardSort" -->
        <ChatWindow ref="child" :chatWindowInfo="chatWindowInfo" :innerText="innerText" :inputStr="inputStr"
          :apiInfo="apiInfo" :chatList="chatList" @closeLeft="closeLeftFun" @closeRight="closeRightFun"
          @bandUserId="bandUserId" @answerComplete="answerComplete" @isLikedFun="isLikedFun" v-show="showChatWindow"
          @sendMsg="sendMsgFun" :isRiskAssessment="isRiskAssessment"></ChatWindow>
      </div>
    </div>

    <div class="chatRightSetting" v-if="showRight">
      <div class="searchBox">
        <input class="inputs" v-model="inputMsg" placeholder="搜索提示..." />
      </div>
      <!-- 提示列表 -->
      <div class="promptListBox">
        <div v-for="(item, key) in promptList" :key="key">
          <el-upload action="" accept=".pdf,.doc, .docx" :show-file-list="false" :http-request="handelUpload"
            v-if="item.index == 12" :disabled="isSendMsg" class="item">
            <template>
              <div>
                <span class="el-icon-s-opportunity"></span>
                <span class="text">{{ item.title }}</span>
              </div>
            </template>
          </el-upload>

          <div class="item" @click="openWind(item)" v-else>
            <span class="el-icon-s-opportunity"></span>
            <span class="text">{{ item.title }}</span>
          </div>
        </div>
      </div>
      <!-- el-icon-s-opportunity -->
    </div>

    <!-- 案例\提示弹框 -->
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" class="bgColor"
      :class="{'riskAssessmentModal': index === 13}" @closed="dialogClose">
      <!-- <div class="headerBox">
        <div>
          <img :src="tip" alt="" srcset="" />
          案例
        </div>
        <div>
          <img :src="al" alt="" srcset="" />
          提示
        </div>
      </div> -->
      <div class="dialog_Content">
        <div class="leftBox">

          <!-- 医学影像 -->
          <div v-if="index === 11">
            <p class="tip">{{ headerTitile }}:</p>
            <div class="imgBox">
              <el-upload class="avatar-uploader" action="" :limit="3" ref="imgUpload" accept="image/*"
                list-type="picture-card" :file-list="imageList" :auto-upload="false" :on-exceed="handleExceed"
                :on-change="handleImgChange" :on-remove="handleRemove">
                <template>
                  <i class="el-icon-plus avatar-uploader-icon" slot="trigger"></i>
                </template>
              </el-upload>
            </div>
            <p class="tip">{{ modelInfo.subHeaderTitile }}:</p>
            <div class="inputBox">
              <el-input type="textarea" placeholder="请输入内容" v-model="caseText" :rows="8" resize="none" />
            </div>
          </div>
          <!-- 健康风险评估 -->
          <div v-else-if="index === 13">
            <p class="tip" style="margin-bottom: 20px; margin-left: 15px;">{{ headerTitile }}:</p>
            <el-row :gutter="20">
              <el-col :span="8" v-for="(item,k) in riskAssessmentTypes" :key="k">
                <el-button style="margin-bottom: 20px; margin-left: 15px;width: 140px;"
                  @click="handelRiskAssessment(item)">{{item.name}}</el-button>
              </el-col>
            </el-row>
          </div>

          <template v-else>
            <p class="tip">{{ headerTitile }}:</p>
            <div class="inputBox">
              <el-input type="textarea" placeholder="请输入内容" v-model="caseText" :rows="15" resize="none">
              </el-input>
            </div>
          </template>
          <div class="footerBtn" v-if="index !== 13">
            <el-button type="primary" icon="el-icon-document-copy" @click="quoteFun">{{ index == 11 ? "开始识别" : "引用案例"
              }}</el-button>
          </div>
        </div>
        <!-- <div class="splitBox"></div>
        <div class="rightBox">
          <p class="tip">名称</p>
          <div class="inputBox">
            <el-input type="text" placeholder="请输入内容" v-model="name">
            </el-input>
          </div>
          <p class="tip mar-t-24">描述</p>
          <div class="inputBox">
            <el-input type="text" placeholder="请输入内容" v-model="describe">
            </el-input>
          </div>
          <p class="tip mar-t-24">提示词</p>
          <div class="inputBox">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="cueWord"
              :rows="5"
            >
            </el-input>
          </div>

          <div class="footerBtn">
            <el-button
              type="info"
              icon="el-icon-document-copy"
              @click="quoteCaseFun"
              >引用提示</el-button
            >
          </div>
        </div> -->
      </div>
    </el-dialog>

    <!-- 引用提示 -->
    <el-dialog :visible.sync="dialogVisibleCase" :before-close="handleCaseClose" class="bgColor">
      <div class="caseBox">
        <div>
          {{ extractedTextObj.name }}
        </div>
        <div class="desc">
          {{ extractedTextObj.describe }}
        </div>
        <div class="inputListBox" v-for="(item, index) in extractedTextObj.inputList" :key="index">
          <p class="tip mar-t-24 normal">{{ item.title }}</p>
          <div class="inputBox">
            <el-input type="textarea" placeholder="请输入内容" v-model="item.value" :rows="5">
            </el-input>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitText">提交</el-button>
      </div>
    </el-dialog>

    <!--inputKey 输入key弹框 -->
    <!-- <el-dialog
      :visible.sync="inputKey"
      :show-close="false"
      :close-on-click-modal="false"
      class="bgColor"
      title=""
    >
      <div class="keyBox">
        <p class="tip">
          <i class="el-icon-info"></i>
          温馨提示
        </p>
        <p class="tipText">
          请在先下面输入框输入微域Aigma密钥（任意16位字符串即可）
        </p>
        <div class="btnBox">
          <el-input
            placeholder="请输入微域Aigma密钥"
            v-model="inputKeyStr"
            maxlength="16"
          >
          </el-input>
          <el-button type="primary" @click="inputKeyFun">确认</el-button>
        </div>
      </div>
    </el-dialog> -->
    <!-- :before-close="inputKeyClose" -->
  </div>
</template>

<script>
  import al from "@/assets/img/al.webp";
  import tip from "@/assets/img/tip.webp";
  import PersonCard from "@/components/PersonCard.vue";
  import ChatWindow from "./chatwindow.vue";
  const Mustache = require("mustache");
  import {
    getList,
    createChat,
    deleteChat,
    clearAll,
    getHisPage,
    isLiked,
  } from "@/api/getData";
  import Cookies from "js-cookie";
  export default {
    name: "App",
    components: {
      PersonCard,
      ChatWindow,
    },
    watch: {
      imageList(val) {
        if (
          this.dialogVisible &&
          this.$refs.imgUpload &&
          this.$refs.imgUpload.$children &&
          this.$refs.imgUpload.$children.length > 1
        ) {
          if (val.length < 3) {
            this.$refs.imgUpload.$children[1].$el.style.display = "";
          } else {
            this.$refs.imgUpload.$children[1].$el.style.display = "none";
          }
        }
      },
    },
    data() {
      return {
        al,
        tip,
        inputKey: false,
        inputKeyStr: "",
        innerText: "",
        inputStr: "",
        index: 0,
        text: "",
        caseText: "",
        name: "",
        describe: "",
        cueWord: "",
        pcCurrent: "",
        personList: [],
        showChatWindow: false,
        chatWindowInfo: {},
        chatList: [],
        apiInfo: {},
        settingList: [
          { name: "清空对话", icon: "el-icon-delete" },
          { name: "退出登录", icon: "el-icon-user" },
        ],
        inputMsg: "",
        showLeft: true,
        showRight: true,
        promptList: [
          {
            headerTitile: "请选择风险评估类型",
            subHeaderTitile: "",
            title: "健康风险评估",
            case: "",
            name: "",
            describe: "",
            cueWord: "",
            index: 13,
          },
          {
            headerTitile: "",
            subHeaderTitile: "",
            title: "健康方案制定",
            case: "",
            name: "",
            describe: "",
            cueWord: "",
            content: "请帮我制定一份详细的健康管理方案",
            index: 14,
          },
          {
            headerTitile: "请上传报告解读",
            subHeaderTitile: "",
            title: "报告解读",
            case: "请模拟一个心理医生，针对患者的问题进行心理安慰：我最近脾气很暴躁",
            name: "心理咨询",
            describe: "模拟心理医生，帮助解决患者心理问题",
            cueWord: "",
            index: 12,
          },
          {
            title: "指标解读",
            case: "请解释下列指标的意义：TSH0.2mIU/L，FT3 20.1pmol/L，FT4 42pmol/L",
            name: "指标解读",
            describe: "输入用户检验单指标，生成异常指标的解读及建议",
            cueWord: "请解释下列指标的意义，指标为{{指标}}",
            headerTitile: "请输入你需要进行解读的指标",
            index: 6
          },
          {
            headerTitile:
              "请输入患者的基本信息（包含：身高、体重、年龄、基础病信息、劳动强度）",
            title: "饮食指导",
            case: "请模拟一个心理医生，针对患者的问题进行心理安慰：我最近脾气很暴躁",
            name: "心理咨询",
            describe: "模拟心理医生，帮助解决患者心理问题",
            cueWord:
              "请模拟一个心理医生，针对患者的问题进行心理安慰，患者主诉为{{患者主诉}}",
            index: 10,
          },
          {
            headerTitile: "请输入你心理方面问题",
            title: "心理咨询",
            case: "请模拟一个心理医生，针对患者的问题进行心理安慰：我最近脾气很暴躁",
            name: "心理咨询",
            describe: "模拟心理医生，帮助解决患者心理问题",
            cueWord:
              "请模拟一个心理医生，针对患者的问题进行心理安慰，患者主诉为{{患者主诉}}",
            index: 9,
          },
          {
            index: 5,
            headerTitile:
              "请输入你的基本生活情况（包含：年龄、身高、体重，是否饮酒、吸烟、饮食情况、是否保持运动等）",
            title: "疾病风险预测",
            case: "请根据该用户的基本情况做风险预测，评估其未来5年患心脑血管疾病的风险，风险等级请用高、中、低风险表示。生成风险结果后，请列举该用户心脑血管疾病有关的异常风险因素，列举异常风险因素的改善建议。\n用户健康档案：年龄：45岁；身高：178cm；体重：89Kg；吸烟15年，平均每天1包，胆固醇偏高，几乎不运动，饮食以青菜为主",
            name: "疾病风险预测",
            describe:
              "输入用户健康档案（年龄、性别、身高、体重、指标、饮食习惯、运动习惯、生活习惯、既往病史、家族病史等），以及疾病名称，预测用户未来5-10年患该疾病的风险",
            cueWord:
              "请根据该用户的基本情况做风险预测，评估其未来5年患{{疾病名}}的风险，风险等级请用高、中、低风险表示。生成风险结果后，请列举该用户与该疾病有关的异常风险因素，列举异常风险因素的改善建议，用户健康档案为{{健康数据}}",
          },


          {
            title: "导诊-科室建议",
            case: "请根据下述患者的病情，推荐合适的就诊科室，科室请从以下候选中选择：\n骨科、泌尿外科、内分泌科、普外科、呼吸内科、消化内科\n患者病情：尿频，血尿",
            name: "导诊-科室建议",
            describe:
              "输入主诉（症状、疾病、检查检验、用药等）以及指定的科室名，生成导诊科室建议",
            cueWord:
              "请根据下述患者的病情，推荐合适的就诊科室，科室请从以下候选中选择：{{科室名}}、患者病情为：{{患者病情}}",

            headerTitile: "请输入你的病情",
            index: 0,
          },
          {
            title: "生成病历",
            case: "病历生成：根据问诊对话，以医学书面语的方式生成病历，内容包括主诉、现病史、既往史、个人史、家族史、疾病诊断、处理建议等。\n问诊对话：\n医生：您好，请问您有什么不舒服的地方需要咨询吗？\n患者：我有反复的上腹部疼痛已经有3年了，最近3个月症状更加严重。\n医生：能具体描述一下疼痛的性质吗？\n患者：隐约的疼,不是特别剧烈。\n医生：疼痛与吃饭有关系吗？有没有感觉饥饿或者餐后疼痛会加剧\n患者：一般吃完饭疼的会更厉害。\n医生：除了上腹痛，还有其他表现吗患者：反酸、嗳气。\n医生：好的，您是否有发热、黄疸、呕血或者黑便的情况\n患者：没有，这些症状我都没有出现过。\n医生：出现这种情况后去医院看过吗？\n患者：在当地诊所看过，开了吗丁啉\n医生：用药后疗效如何？\n患者：腹痛会缓解一些。\n医生：平时抽烟吗？\n患者：是的，我吸烟已经有10多年了。\n医生：在您的家族中，是否有人有高血压的病史？\n患者：我父亲有高血压的病史。\n医生：好的，最后我想问一下，您是否有过敏史？\n患者：没有，我没有任何过敏史。\n医生：根据您的症状和病史，我初步怀疑您可能患有慢性胃炎。为了更好地了解您的情况，我建议您进行大便潜血和胃镜检查。",
            name: "生成病历",
            describe: "输入问诊对话，生成病历",
            cueWord:
              "根据问诊对话，以医学书面语的方式生成病历，内容包括主诉、现病史、既往史、个人史、家族史、过敏史、诊断、处理建议，对话为{{问诊对话}}",
            headerTitile: "请输入你和医生的对话",
            index: 1,
          },
          {
            title: "问诊对话",
            case: "现在你作为一名医生，你的任务是对患者进行多轮交互问诊，尽可能详细地了解患者病情，最终给出初步诊断和建议。患者:头疼",
            name: "问诊对话",
            describe: "根据患者主诉，模拟医生进行问诊",
            cueWord:
              "现在你作为一名医生，你的任务是对患者进行多轮交互问诊，尽可能详细地了解患者病情，最终给出初步诊断和建议，主诉为{{患者主诉}}",
            headerTitile: "请输入你目前的主诉",
            index: 2,
          },
          {
            title: "检查检验推荐-对话",
            case: '下面是一段医生和患者的对话，假设你是一名医生，请给出"建议检查"\n患者：我最近发热、咳嗽，还有咳红色痰，而且右侧胸痛，已经持续两天了\n医生：是否有其他不适感觉？比如头痛、乏力、呼吸困难等\n患者：没有头痛和乏力，但有点呼吸急促\n医生：除了胸痛，你还有其他部位的疼痛吗，比如腹痛或关节痛\n患者：没有其他部位的疼痛，只有右侧胸痛\n医生：你有没有感觉呼吸困难加重或者活动时加重的情况\n患者：我感觉呼吸困难在咳嗽时会加重一些\n医生：你之前起病前有没有受到雨淋或者湿冷环境的暴露\n患者：我确实遭雨淋了\n医生：有没有血丝或血块混在痰中\n患者：没有血丝或血块混在痰中，只是像是铁锈色的痰\n医生：除了这次的症状，你还有患过其他慢性病的历史吗，比如高血压、糖尿病等\n患者：没\n医生：你是否曾经患过肝炎或结核等传染病\n患者：没\n医生：你有没有最近进行过手术或遭受外伤\n患者：没有医生：之前检查过\n患者：不好意思，没\n医生：你有没有其他家族成员或同事朋友有相似的症状\n患者：没有，我是唯一出现这些症状的人\n医生：你最近有没有接触过有呼吸道感染病史的人\n患者：没\n医生：你有没有吸烟或酗酒的习惯患者：没有，我从来不吸烟和酗酒。',
            name: "检查检验推荐-对话",
            describe: "根据医患问诊对话，给患者推荐检查检验项目",
            cueWord:
              "下面是一段医生和患者的对话，假设你是一名医生，请给出'建议检查'，对话为{{医患对话}}",
            headerTitile: "请输入你和医生的对话内容",
            index: 3,
          },
          {
            title: "检查检验推荐-病情",
            case: "根据以下患者的情况，给出该患者应该去做的检查检验项目，并给出推荐原因\n患者病情:女性，小腹疼痛，白带增多、异味",
            name: "检查检验推荐-病情",
            describe: "输入患者病情，生成检查检验建议",
            cueWord:
              "根据以下患者的情况，给出该患者应该去做的检查检验项目，并给出推荐原因，患者病情为{{病情}}",
            headerTitile: "请输入你的病情",
            index: 4,
          },


          {
            headerTitile:
              "请输入你的基本情况（应包含：年龄、性别、孕哺情况、临床诊断）",
            title: "处方推荐",
            case: "根据患者的年龄、性别、孕哺情况、临床诊断，给该患者推荐合理的处方，处方包括药品名称、规格、用法用量患者病情：\n患者性别女、25岁，孕22周，怕冷、乏力，经检查诊断为甲状腺功能减退症",
            name: "处方推荐",
            describe:
              "输入患者病情（年龄、性别、孕哺情况、临床诊断、禁忌症、过敏史等），生成用药建议",
            cueWord:
              "根据患者的年龄、性别、孕哺情况、临床诊断、禁忌症、过敏史，给患者推荐处方，处方包括药品名称、规格、用法用量，患者的病情如下{{患者病情}}",
            index: 7
          },
          {
            index: 8,
            headerTitile: "请输入你想问患者的问题",
            title: "医生培训",
            case: "我是一名医生，你来扮演一名哮喘急性发作患者，我们来模拟一场问诊，我想通过这样的模拟来锻炼我的接诊能力。您觉得哪里不舒服",
            name: "医生培训",
            describe: "模拟患者和主诉，帮助医生做问诊培训",
            cueWord:
              "我是一名医生，你来扮演一名{{疾病名}}患者，我们来模拟一场问诊，我想通过这样的模拟来锻炼我的接诊能力。您觉得哪里不舒服？",

          },


          {
            headerTitile: "请上传医学影像图片",
            subHeaderTitile: "请输入您的问题",
            title: "医学影像识别",
            case: "请模拟一个心理医生，针对患者的问题进行心理安慰：我最近脾气很暴躁",
            name: "心理咨询",
            describe: "模拟心理医生，帮助解决患者心理问题",
            cueWord:
              "请模拟一个心理医生，针对患者的问题进行心理安慰，患者主诉为{{患者主诉}}",
            index: 11,
          },



        ],
        dialogVisible: false,
        dialogVisibleCase: false,
        extractedTextObj: {
          name: "",
          describe: "",
          inputList: [],
        },
        headerTitile: "11",
        promptTipList: [
          {
            text: "假如你是一个医生助理，请根据下述患者的病情为他推荐合适的就诊科室，如果你觉的描述不清楚，请继续追问问题，患者病情：",
          },
          {
            text: "假如你是一个医生助理，请根据下述患者和医生的对话以医学书面语的方式生成病历，内容包括主诉、现病史、既往史、个人史、家族史、过敏史、诊断、处理建议，对话为：",
          },
          {
            text: "假如你是一个医生助理，你的任务是对患者进行多轮交互问诊，如果有多个问题需要追问，请注意一个一个问题顺序向患者提问，尽可能详细地了解患者病情，最终给出初步诊断和建议，患者主诉为：",
          },
          {
            text: "假如你是一个医生助理，根据下面这段医生和患者的对话，请给出'建议检查'，对话为：",
          },
          {
            text: "假如你是一个医生助理，根据以下患者的情况，给出该患者应该去做的检查检验项目，并给出推荐原因，患者病情为：",
          },
          {
            text: "假如你是一个医生助理，请根据该用户的基本情况做风险预测，评估其未来5年患疾病的风险，风险等级请用高、中、低风险表示。",
          },
          {
            text: "假如你是一个医生助理,请解释下列指标的意义,指标如下：",
          },
          {
            text: "假如你是一个医生助理,根据患者的年龄、性别、孕哺情况、临床诊断，给该患者推荐合理的处方，处方包括药品名称、规格、用法用量，患者的信息为：",
          },
          {
            text: "假设你是一名哮喘急性发作患者患者,我是一名医生，我们来模拟一场问诊，我想通过这样的模拟来锻炼我的接诊能力，回答我下面的问题：",
          },
          {
            text: "请模拟一个心理医生，针对患者的问题进行心理安慰，下面是患者的心理方面问题：",
          },
          {
            text: "假如你是一名资深的健康管理师,请根据以下的基础信息为患者生成一份一周的食谱，患者的基础信息如下：",
          },
        ],
        // params: {},
        modelInfo: {}, //弹框信息
        imageList: [], //图片列表
        isSendMsg: false, //是否正在发送消息中
        riskAssessmentTypes: [
          {
            name: "高血压风险评估",
            text: "请帮我进行高血压风险评估"
          },
          {
            name: "高血糖风险评估",
            text: "请帮我进行高血糖风险评估"
          },
          {
            name: "高血脂风险评估",
            text: "请帮我进行高血脂风险评估"
          },
          {
            name: "高尿酸风险评估",
            text: "请帮我进行高尿酸风险评估"
          },
          {
            name: "肥胖风险评估",
            text: "请帮我进行肥胖风险评估"
          },
          {
            name: "失眠风险评估",
            text: "请帮我进行失眠风险评估"
          }
        ], //风险评估类型列表
        isRiskAssessment: false,//是否是风险评估

      };
    },
    mounted() {
      this.bandUserId(this.inputKeyStr);
      this.getListFun();
      // if (Cookies.get("apiInfo") && JSON.parse(Cookies.get("apiInfo")).key) {
      //   this.getListFun();
      // } else {
      //   this.inputKey = true;
      // }
    },
    methods: {
      // 风险评估按钮点击事件
      handelRiskAssessment(item) {
        this.isRiskAssessment = true;
        // 创建会话
        this.newChat(() => {
          if (this.$refs.child) this.$refs.child.sendRiskAssessment(item);
          this.dialogVisible = false;
        });
      },
      // 上传文件
      handelUpload(e) {
        this.isRiskAssessment = false;
        let { file } = e;
        let data = {
          file,
        };
        if (this.$refs.child) this.$refs.child.sendReport(data);
      },
      // 发送消息
      sendMsgFun(val) {
        this.isSendMsg = val;
      },
      // 图片上传超出数量上传事件
      handleExceed() {
        this.$message.warning("最多只能上传三张图片！");
      },
      // 图片上传事件
      handleImgChange(file, fileList) {
        this.imageList = fileList;
      },
      // 图片移除事件
      handleRemove(file, fileList) {
        this.imageList = fileList;
      },
      // 图文影像弹框关闭事件
      dialogClose() {
        this.imageList = [];
      },
      inputKeyClose() {
        this.inputKey = false;
      },
      // 引用案例
      quoteFun() {
        this.isRiskAssessment = false;
        if (this.index == 11) {
          this.submitImage();
          return;
        }
        this.innerText = this.caseText;
        this.inputStr =
          this.promptTipList[this.index].text + `'''${this.caseText}'''`;
        this.dialogVisible = false;
      },
      // 发送医学影像事件
      submitImage() {
        if (this.imageList.length == 0)
          return this.$message.warning("请上传图片");
        if (!this.caseText) return this.$message.warning("请输入内容");
        let formData = new FormData();
        formData.append("prompt", this.caseText);
        this.imageList.map((item) => formData.append("file", item.raw));
        let imgs = this.imageList.map((item) => item.url);
        let data = {
          prompt: this.caseText,
          imgs,
          formData,
        };
        if (this.$refs.child) this.$refs.child.sendImage(data);
        this.dialogVisible = false;
      },

      // 引用案例
      quoteCaseFun() {
        this.dialogVisible = false;
        this.extractedTextObj.name = this.name;
        this.extractedTextObj.describe = this.describe;
        const regex = /{{(.*?)}}/g;
        const matches = this.cueWord.match(regex);
        const list = [];
        if (matches) {
          for (var i = 0; i < matches.length; i++) {
            const match = matches[i];
            const extractedText = match.substring(2, match.length - 2);
            list.push(extractedText);
          }
        }
        this.extractedTextObj.inputList = [];
        list.map((item, index) => {
          this.extractedTextObj.inputList.push({
            title: item,
            value: "",
          });
        });

        this.dialogVisibleCase = true;
      },
      submitText() {
        let obj = {};
        this.extractedTextObj.inputList.map((item) => {
          obj[item.title] = item.value;
        });
        this.innerText = Mustache.render(this.cueWord, obj);
        this.dialogVisibleCase = false;
      },
      // 回答完成
      answerComplete() {
        this.innerText = "";
      },
      loginOut(index) {
        // 退出登录
        if (index == 1) {
          sessionStorage.removeItem("adminToken");
          this.$router.push("/login");
        }
        // 清空会话(右边聊天框)
        if (index == 0) {
          let data = {
            id: this.pcCurrent,
          };
          clearAll(data).then((res) => {
            if (res.code == 200) {
              this.$message.success("清空会话成功");
              if (this.$refs.child) this.$refs.child.reset();
              this.getHisPageFun(this.personInfo.sessionId);
            }
          });
        }
      },
      closeLeftFun(val) {
        this.showLeft = val;
      },
      closeRightFun(val) {
        this.showRight = val;
      },
      newChat(callback) {
        createChat().then((res) => {
          if (res.code == 200) {
            this.getListFun(callback);
          }
        });
      },
      // 删除
      deleteOnce(index) {
        let id = this.personList[index].id;
        let data = {
          id: id,
        };
        deleteChat(data).then((res) => {
          if (res.code == 200) {
            this.getListFun();
          }
        });
      },
      // 编辑会话名
      changeName() {
        this.getListFun();
      },
      clickPerson(info, callback) {
        this.chatWindowInfo = info;
        this.personInfo = info;
        this.pcCurrent = info.id;
        this.getHisPageFun(this.personInfo.sessionId, callback);
      },
      // personCardSort(id) {
      //   if (id !== this.personList[0].id) {
      //     console.log(id);
      //     let nowPersonInfo;
      //     for (let i = 0; i < this.personList.length; i++) {
      //       if (this.personList[i].id == id) {
      //         nowPersonInfo = this.personList[i];
      //         this.personList.splice(i, 1);
      //         break;
      //       }
      //     }
      //     this.personList.unshift(nowPersonInfo);
      //   }
      // },
      inputKeyFun() {
        this.bandUserId(this.inputKeyStr);
      },
      // 患者绑定
      bandUserId(val) {
        let data = {
          userKey: val,
        };
        // data
        getList().then((res) => {
          if (res.code == 200) {
            this.personList = res.data;
            this.apiInfo = {
              key: val,
            };
            Cookies.set("apiInfo", JSON.stringify(this.apiInfo), { expires: 7 });
            this.inputKey = false;
            this.getListFun();
          }
        });
      },

      // 查询会话列表
      getListFun(callback) {
        // let data = {
        //   userKey: JSON.parse(Cookies.get("apiInfo")).key,
        // };
        // data
        getList().then((res) => {
          if (res.code == 200) {
            this.personList = res.data;
            this.clickPerson(this.personList[0], callback);
          }
        });
      },
      // 打开对应弹框
      openWind(item) {
        let { index } = item;
        if (this.isSendMsg) return;
        // index  0 - 导诊科室建议  1-生成病历  2-问诊对话  3-检查检验推荐 4-检查检验推荐-病情 5-疾病风险预测 6-指标解读 7-处方推荐 8-医生培训 9-心理咨询 10饮食指导 11-医学影像识别识别 12-报告解读 13健康风险评估 14健康方案制定
        this.index = index;
        let obj = item;
        this.headerTitile = obj.headerTitile;
        this.caseText = "";
        this.name = obj.name;
        this.describe = obj.describe;
        this.cueWord = obj.cueWord;
        this.modelInfo = obj;
        if (index == 14) {
          this.handelRiskAssessment({
            name: 'healthPlan',
            text: obj.content,
          });
          return;
        }
        this.$nextTick(() => {
          this.dialogVisible = true;
        });
      },

      handleClose() {
        this.dialogVisible = false;
      },

      handleCaseClose() {
        this.dialogVisibleCase = false;
      },

      // 查询对应消息记录
      getHisPageFun(sessionId, callback) {
        let data = {
          sessionId,
          page: 1,
          limit: 1000,
          sort: 2,
        };
        this.chatList = [];

        getHisPage(data).then((res) => {
          if (res.code == 200) {
            res.data && res.data.records
              ? res.data.records.map((item) => {
                this.chatList.unshift(item);
              })
              : "";
            this.showChatWindow = true;
            this.$refs.child.scrollBottom();
            if (callback && typeof callback == 'function') {
              callback();
            }
          }
        });
      },

      // 喜欢\不喜欢
      isLikedFun(index, val) {
        let data = {
          liked: val,
          id: this.chatList[index].id,
        };
        isLiked(data).then((res) => {
          if (res.code == 200) {
            this.$set(this.chatList[index], "liked", val);
            console.log("hh");
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .chatHome {
    // margin-top: 20px;
    display: flex;

    .chatLeft {
      width: 280px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .topBtn {
        height: 21px;
        padding: 12px;
        border: 1px solid red;
        text-align: center;
        display: flex;
        align-items: center;
        color: #fff;
        border-radius: 4px;
        border-color: hsla(0, 0%, 100%, 0.2);
        cursor: pointer;

        .text {
          margin-left: 10px;
        }
      }

      .online-person {
        flex: 1;
        min-height: calc(100vh - 300px);

        .onlin-text {
          padding-left: 10px;
          color: rgb(176, 178, 189);
        }

        .person-cards-wrapper {
          height: 100%;
          overflow: hidden;
          overflow-y: scroll;
          box-sizing: border-box;

          &::-webkit-scrollbar {
            width: 0;
            /* Safari,Chrome 隐藏滚动条 */
            height: 0;
            /* Safari,Chrome 隐藏滚动条 */
            display: none;
            /* 移动端、pad 上Safari，Chrome，隐藏滚动条 */
          }
        }

        .person-cards-wrapper:first-child {
          margin-top: 0px;
        }
      }

      .bootomSetting {
        height: 200px;
        // background: red;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        color: #fff;
        border-top: 1px solid rgba(255, 255, 255, 0.2);

        .item {
          display: flex;
          align-items: center;
          height: 40px;
          cursor: pointer;
          padding: 0px 12px;
          box-sizing: border-box;

          p {
            margin-left: 10px;
          }
        }
      }
    }

    .chatRight {
      flex: 1;
      padding-right: 30px;

      .showIcon {
        position: absolute;
        top: calc(50% - 150px);
        /*垂直居中 */
        left: calc(50% - 50px);

        /*水平居中 */
        .icon-snapchat {
          width: 300px;
          height: 300px;
          font-size: 300px;
          // color: rgb(28, 30, 44);
        }
      }
    }

    .chatRightSetting {
      width: 280px;

      .topBtn {
        height: 21px;
        padding: 12px;
        border: 1px solid red;
        text-align: center;
        display: flex;
        align-items: center;
        color: #fff;
        border-radius: 4px;
        border-color: hsla(0, 0%, 100%, 0.2);
        cursor: pointer;

        .text {
          margin-left: 10px;
        }
      }

      .searchBox {

        // margin: 12px 0px;
        .inputs {
          width: 280px;
          height: 40px;
          background-color: rgb(39, 42, 55);
          padding: 4px 10px;
          border-radius: 6px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-color: hsla(0, 0%, 100%, 0.2);
          box-sizing: border-box;
          transition: 0.2s;
          font-size: 16px;
          color: #fff;
          font-weight: 100;

          &:focus {
            outline: none;
          }
        }
      }

      .promptListBox {
        color: #fff;
        cursor: pointer;

        .item {
          margin: 12px 0px;
          height: 42px;
          display: flex;
          align-items: center;
          padding: 0px 12px;
          border-radius: 6px;

          .text {
            margin-left: 10px;
          }

          &:hover {
            background-color: rgba(72, 101, 255, 0.8);
            transition: 0.3s;
            box-shadow: 0 5px 20px rgba(52, 53, 65, 0.8);
          }
        }
      }
    }

    .dialog_Content {


      .imgBox {
        display: flex;

        .avatar-uploader {
          margin-top: 12px;

          :deep(.el-upload) {
            background: transparent;
            margin-bottom: 12px;
          }
        }
      }


    }
  }

  .riskAssessmentModal {
    :deep(.el-dialog) {
      width: 600px;
      height: 400px;

      .dialog_Content {
        height: auto;
      }
    }


  }
</style>